import {
	AlertDialog,
	AlertDialogOverlay,
	AlertDialogContent,
	AlertDialogHeader,
	AlertDialogCloseButton,
	AlertDialogBody,
	AlertDialogFooter,
	Text,
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import ButtonCTA from '../globalComponents/button/index'
import { useUpdateCancelRequest } from '../../hooks/activity.hooks'
import { useSharedContext } from '../../context/shared.context'
import { useLanguageContext } from './../../context/locale.context'
import { sharedConst } from '../../utils/action.constant'

const WhatNextCancelRequest = ({ onClose }) => {
	const {
		state: { locale },
	} = useLanguageContext()

	const { mutate: cancelRequest, isLoading: loadingCancelRequest } =
		useUpdateCancelRequest()

	const {
		state: {
			activity: {
				activity_title,
				activity_id,
				activity_type_id,
				activity_type_category_id,
			},
		},
		dispatch,
	} = useSharedContext()

	const onCancelRequest = () => {
		cancelRequest(
			{
				activity_id,
				activity_type_id,
				activity_type_category_id,
				workflow_activity_id: activity_id,
			},
			{
				onSuccess: async res => {
					onClose()
					setTimeout(() => {
						dispatch({
							type: sharedConst.ACTVITY_SELECTED,
							payload: null,
						})
						dispatch({
							type: sharedConst.REFRESH_LISTING,
						})
					}, 1000)
				},
				onError: async err => console.log(err),
			}
		)
	}

	return (
		<>
			<AlertDialog isOpen={true} onClose={onClose} isCentered>
				<AlertDialogOverlay>
					<AlertDialogContent borderRadius='sm'>
						<AlertDialogHeader fontSize='1rem' fontWeight='500'>
							{locale['Cancel Request']}
						</AlertDialogHeader>
						{/* <Divider /> */}
						<AlertDialogCloseButton color='red.600' />
						<AlertDialogBody>
							<Text fontWeight='500' fontSize='0.875rem'>
								Do you want to close <strong>{activity_title}</strong>?
							</Text>
						</AlertDialogBody>
						<AlertDialogFooter>
							<ButtonCTA
								variant='whatsNextButton'
								onClick={onClose}
								disabled={loadingCancelRequest}
							>
								{locale['Cancel']}
							</ButtonCTA>
							<ButtonCTA
								variant='whatsNextButton'
								color='white'
								bg='blue.600'
								onClick={onCancelRequest}
								ml={3}
								isLoading={loadingCancelRequest}
							>
								{locale['Submit']}
							</ButtonCTA>
						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
		</>
	)
}

WhatNextCancelRequest.propTypes = {
	onClose: PropTypes.func.isRequired,
}

export { WhatNextCancelRequest }
